import MaterialsBill from '../components/config/distinta.json'


function isNumber(value) {
    return typeof value === 'number' && isFinite(value);
}

function b64EncodeUnicode(str) {
    let buff = Buffer(str);
    return buff.toString("base64");
}

function SendOrderMail(billconfig, replyTo, callback)
{
    const apikey = '1yZxRhvYBa97A7gSoXFSZ805wNumIyoB3T4qtViu';
    const MailObject = 'Leggera Lift Order';
    const messageBody = 'Order request from leggeraliftvilla.com';
    

    const csvstring = GetCSVBillCalculation(billconfig);
    const base64csv = 'data:text/csv;base64,'+b64EncodeUnicode(csvstring);
    const mailTo = "luca.ricchi@espertia.com, paolo.masini@starlift.it, gabriele.gnomi@starlift.it";

    const emailData = {
        "toEmails": mailTo, 
        "replyTo": replyTo, 
        "subject": MailObject, 
        "message": messageBody, 
        "attachments": base64csv
    }

    fetch(
        "https://u7et0pqrk5.execute-api.us-east-1.amazonaws.com/prod/send",
        {
          headers: {
            "x-api-key": apikey,
          },

          body: JSON.stringify(emailData),
          method: "POST",
        }
      )
        .catch( error=>{
          alert(error.message)
        })

        .then( res=>{
            alert('OK Mail sent');
            callback(false);
        }
    )
}

function Capitalize(word) {
    const subwords = word.split('_');
  
    const result = subwords.map( w=>{
      const lower = w.toLowerCase();
      return w.charAt(0).toUpperCase() + lower.slice(1) + ' ';
    })
    return result;
  }
  
function BillCalculation(config){

    let newbill = MaterialsBill;

    Object.keys(newbill).forEach( sect=>{
            Object.keys(newbill[sect]).forEach( subsect=>{
                let obj = newbill[sect][subsect]
                if( obj.calc ){
                    obj.qty = 0;
                    Object.keys(obj.calc).forEach( k=>{
                        obj.qty += config[k]*obj.calc[k];
                    })
                    if(obj.um==='mt') obj.qty/=100;
                    if(obj.um==='mq') obj.qty/=10000;
                    if( obj.k ) 
                        obj.qty += obj.k;
                    
                }
                if( obj.copy ){
                    obj.qty = config[obj.copy];
                }
                if( isNumber(obj.qty) )
                    obj.qty = obj.qty.toFixed(2);
            })
        }
    )

    return(newbill);
}

function ConfigCalculation(config){

    // Calculate RUN
    // from lift Base to last floor base
    let travel = 0;
    for (let i = 0; i < config.lift.floors.length-1; i++) 
    travel += config.lift.floors[i].height+config.lift.floors[i].ceil.height;

    // Calculate HEAD
    // last floor height + last floor ceil width
    let headroom = config.lift.floors[config.lift.floors.length-1].height+
               config.lift.floors[config.lift.floors.length-1].ceil.height;

    // Calculate doors number and area
    let doorsnum = 0;
    let doorsarea = 0;
    for (let i = 0; i < config.lift.floors.length-1; i++) 
    {
        doorsnum += Object.keys(config.lift.floors[i].doors).length;
        const dk = Object.keys(config.lift.floors[i].doors);
        for (let k = 0; k < dk.length; k++) {
            if(['a','c'].includes(dk[k]) )
                doorsarea +=  config.cabin.height * config.lift.model.dimensions.depth
            else
                doorsarea +=  config.cabin.height * config.lift.model.dimensions.width
        }
    }

    return ( 
        {
            "car":      config.lift.model.modelname,
            "travel":   travel,
            "headroom": headroom,
            "doors":    doorsnum,
            "capacity": config.lift.model.capacity,
            "sidesarea": (config.lift.model.dimensions.depth+22)*2*(travel+headroom)+
                         config.lift.model.dimensions.width*(travel+headroom),
            "doorsarea": doorsarea
        }
    )
}


function GetCSVBillCalculation(billconfig)
{
    var billList;
    Object.keys(billconfig).forEach( sectName=>{
        Object.keys(billconfig[sectName]).forEach(subsectName=>{
            const subsect = billconfig[sectName][subsectName];
            billList += `"${subsect.leggera_code?subsect.leggera_code:""}", "${sectName}", "${subsectName}", "${subsect.supplier_descr}", "${subsect.um}", "${subsect.qty}";\n`;
        })
    })
    return billList;
}



export { ConfigCalculation,  BillCalculation, GetCSVBillCalculation, SendOrderMail, Capitalize};